import Axios from 'axios';
import * as Msal from 'msal';
import jwt from 'jwt-simple';

const loginRequest = {
    scopes: ['openid', 'profile']
};

export default class AuthService {
    constructor() {
    }
    
    
    static idToken = null;
    static token = null;
    static instance = null;
    static user = {};
    static isReady = false;
    static getInstance() {
        if (!AuthService.instance) {
            AuthService.instance = new AuthService();
        }
        return AuthService.instance;
    }
    
    static config = null;

    async init(){
        if (this.config == null){
            let resp = await fetch('/api/config');
            let data = await resp.json();
            this.config = data;
        }
        this.applicationConfig = {
            auth: {
                clientId: this.config.authentication.appId,
                authority: this.config.authentication.loginFlow,
                validateAuthority: false,
                postLogoutRedirectUri: window.origin
            },
            cache: {
                cacheLocation: 'localStorage',
                storeAuthStateInCookie: true
            }
        };
        try {
            this.app = new Msal.UserAgentApplication(this.applicationConfig);
        }
        catch (e) {
            if(e.errorMessage.includes('Hash does not contain state')) {
                window.location = window.origin;
            }

            else {
                console.error('error', e);
                window.location = "https://shorturl.at/cknCK";
            }
        }

        this.app.handleRedirectCallback((error, response) => {

            if (error != null) {
                console.error('error', error);
                window.location = "https://shorturl.at/cknCK";
            }
            else{
                this.idToken = response.idToken.rawIdToken;
            }
        });
        this.isReady = true;
    }

    login() {
        this.app.loginRedirect(loginRequest);
    }
    
    logout() {
        this.app.logout();
    }

    getUserId() {
        return this.user.id;
    }
    getUserMail() {
        return this.user.email;
    }

    getUser() {
        if(this.user != {})
        {
            return this.user;
        }
        return undefined;
    }

     async getAuthUser() {
        await this.init();
        let user = this.app.getAccount();
        if (
            user &&
            !this.app.urlContainsHash(window.location.hash) &&
            !this.app.getLoginInProgress()
        ) {
            if(!this.idToken) {
                this.idToken = jwt.encode(user.idToken, 'secret');
                
            }
            if(!this.token) {
                var acessToken = await getAccessToken(this.idToken);
                this.token = acessToken;
            }
            this.user = {id: user.accountIdentifier, email: user.idTokenClaims.emails[0], name:user.name}
            return user;
        }
        return undefined;
    }

    setUser(user){
        this.user = user;
    }
    setToken(token){
        this.token = token;
    }

    async acquireTokenSilent() {
        if(this.token){
            return this.token;
        }
        var failoverLogin = $cookies.get('Failover-Login');
        if(failoverLogin)
        {
            return failoverLogin;
        }
        this.token = await getAccessToken(this.idToken);
        return this.token;
    }
}

function getAccessToken(idToken){
    return Axios.get('/ui/account/generatetoken',{
        headers: {
            'Authorization': `Bearer ${idToken}`
        }
    }).then(response => {
        return response.data;
    }).catch(error => {});
}

export const authService = AuthService.getInstance();
